const FET = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="20" height="20" fill="white" />
    <path
      d="M0 0V20H20V0H0ZM6.99187 2.32H8.86179V4.24H6.99187V2.32ZM2.27642 2.32H4.22764V4.24H2.27642V2.32ZM4.14634 6.96V8.88H2.19512V6.96H4.14634ZM3.65854 17.52H2.84553V16.8H3.57724V17.52H3.65854ZM4.22764 13.68H2.27642V11.84H4.22764V13.68ZM8.37398 17.52H7.64228V16.8H8.37398V17.52ZM8.37398 13.04H7.64228V12.32H8.37398V13.04ZM8.94309 8.96H6.99187V7.04H8.94309V8.96ZM13.0894 17.52H12.3577V16.8H13.0894V17.52ZM13.0894 13.04H12.3577V12.32H13.0894V13.04ZM13.0894 8.32H12.3577V7.6H13.0894V8.32ZM13.7398 4.24H11.7886V2.32H13.7398V4.24ZM17.8862 17.52H17.1545V16.8H17.8862V17.52ZM17.8862 13.04H17.1545V12.32H17.8862V13.04ZM17.8862 8.32H17.1545V7.6H17.8862V8.32ZM17.8862 3.68H17.1545V2.96H17.8862V3.68Z"
      fill="#202944"
    />
  </svg>
);
export default FET;
